
const LightGrayBgWrapper = ({ children }) => {
  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f2f2f2", padding: "1rem" }}>
      {children}
    </div>
  )
}

export default LightGrayBgWrapper
